import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "rental-pdf"
    }}>{`Rental PDF`}</h1>
    <p>{`Rental PDF is a user friendly extension for your Rental and Booking site.
It works as an extension for RnB - WooCommerce plugin. It provides options to download invoice from both front-end & backend panels. Here are the list of places from where you can download the invoices.`}</p>
    <p>{`Front-end `}{`[For customer]`}</p>
    <ul>
      <li parentName="ul">{`Cart page`}</li>
      <li parentName="ul">{`Checkout page`}</li>
      <li parentName="ul">{`Thankyou page`}</li>
      <li parentName="ul">{`My account order listing page`}</li>
      <li parentName="ul">{`My account order single page`}</li>
    </ul>
    <p>{`Backend `}{`[For admin/site owner]`}</p>
    <ul>
      <li parentName="ul">{`Order listing page`}</li>
      <li parentName="ul">{`Order details page.`}</li>
    </ul>
    <p>{`It also send invoice as attachment of order place mail`}</p>
    <h3 {...{
      "id": "requirements"
    }}>{`*`}{`Requirements:`}</h3>
    <p>{`You must have the following plugin installed`}</p>
    <p><a parentName="p" {...{
        "href": "https://codecanyon.net/item/rnb-woocommerce-rental-booking-system/14835145"
      }}>{`RnB - WooCommerce plugin`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://wordpress.org/plugins/woocommerce/"
      }}>{`WooCommerce plugin`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://redqsupport.ticksy.com/"
      }}>{`Customer Support`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      